import ZContainer from '@/ZForms/parsers/entities/ZEntityContainer';


export default window.ZForms.registerClass('container.table_list', class ZTableListForm extends ZContainer {
  constructor() {
    super(...arguments);
    this.mergeInRowField = null;
    this.levelOpenType = 'bottom_modal';
    this.childrenField = null;
  }

  async _updateParamsFromRaw(rawData) {
    await super._updateParamsFromRaw(rawData);
    this.levelOpenType = rawData.level_open_type === undefined ? this.levelOpenType : rawData.level_open_type;
  }

  async _updateMetaFromRaw(rawData) {
    await super._updateMetaFromRaw(rawData);
    this.mergeInRowField = rawData.merge_in_row_field != null ? this.contentMeta.fields[rawData.merge_in_row_field] : this.mergeInRowField;
    this.childrenField = rawData.children_field != null ? this.contentMeta.fields[rawData.children_field] : this.childrenField;

    if (this.childrenField != null && this.childrenField.entityForm.isZLinkFieldDefaultForm) {
      this.childrenField.entityForm = this;
    }
  }
});
